import { LoginForm } from "./LoginForm";

/**
 * LoginPage Component
 * Page-level component that composes views
 */
export const LoginPage = () => {
  return <LoginForm />;
};
